import { Tooltip } from "..";
import { Popover } from "@progress/kendo-react-tooltip";
import { useRef } from "react";
import { exclamationCircleIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from '@progress/kendo-react-common';

const TextField = (props: any) => {

  const anchor = useRef<HTMLInputElement>(null);
  
  return (
    <div className={'filter-fields ' + props.additionalClass} key={props.name}>
      {props.labelExternal ? <h3 className="title">{props.label}</h3> : null}
      <div className="d-flex align-items-center justify-content-between">
        <div className="flex-grow-1">
          <input
            // {...props}
            type={props.type}
            name={props.name}
            value={props?.defaultSelected}
            className="form-control"
            disabled={props.disabled ? props.disabled : false}
            placeholder={props.placeholder !== "" ? props.placeholder : null}
            onChange={(e) => props.onChange({ name: props.name, value: e.target.value })}
            ref={anchor}
          />
        </div>
        {props.error &&
        <Popover
            show={true}
            position="bottom"
            anchor={anchor.current && anchor.current}
        >
          <div style={{ maxWidth: 300, padding: "0 0.5rem 0.5rem", display: 'flex', alignItems: 'center', gap: 2 }}>
               <SvgIcon icon={exclamationCircleIcon} size="default" style={{ color: 'var(--blue, #5464B0)', marginRight: 8 }} />
            <span>{props.error}</span>
          </div>
        </Popover>
        }
        {
          props.hasTooltip && 
          <div className="p-2">
              <Tooltip title={props.label}
            text={props.tooltipText} />
          </div>
        }
      </div>
    </div>
  );
};

export default TextField;